<template>
  <v-layout v-if="" row justify-center>
    <v-dialog :value="visible" persistent max-width="500px">
      <v-card class="">
        <v-card-title class="grey flex xs12 elevation-3">
          <span class="headline">Login</span>
        </v-card-title>
        <v-card-text class="flex xs10 offset-xs1">
          <v-fade-transition>
            <p v-if="failed && loginCount < 3" class="red--text tiny">Username or password was wrong.<br>
              Please try again.<br>
              <small>({{3 - loginCount}} Versuche)</small>
            </p>
          </v-fade-transition>
          <v-fade-transition>
            <p v-if="loginCount === 3">Zu viele Anmeldeversuche. Bitte melde dich beim Administrator.</p>
          </v-fade-transition>
          <v-fade-transition>
            <p v-if="wait">Du wirst in Kürtze eingelogt. Bitte warten...</p>
          </v-fade-transition>
          <v-form v-if="loginCount < 3">
            <v-text-field label="User Name" required v-model="userName"></v-text-field>
            <v-text-field label="Password" type="password" required v-model="pw"
                          @keyup.enter=" authenticate({userName,pw})"></v-text-field>
          </v-form>
          <small v-if="loginCount < 3">*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="loginCount < 3" color="blue darken-1" flat @click.native="authenticate({userName,pw})">login</v-btn>
          <v-btn  color="red darken-1" flat @click.native="$emit('update')">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: 'login',
    computed: {
      ...mapGetters({
        users: 'users',
      }),
    },
    props: {
      visible: {
        type: Boolean,
        required: true
      },
    },
    data() {
      return {
        userName: '',
        pw: '',
        wait: false,
        failed: false,
        loginCount: 0,
      };
    },
    methods: {
      ...mapActions(['logIn', 'getAllUsers', 'getAllMedia', 'getAllSliders', 'getAllNews']),
      /**
       * After succesccfull login first get all users, then set active user
       * @param u
       */
      authenticate(u) {
        this.wait = true
        if (!this.$auth.isAuthenticated()) {
          let data = {
            client_id: 2,
            client_secret: 'Qd7PS05FCBhD62WWnHS9KIFYPa7gf8XMKIbdhTX3',
            grant_type: 'password',
            username: u.userName, // 'okeeling',
            password: u.pw, // 'secret'
          };
          this.$http.post(this.$helper.getLocation()+'/oauth/token', data).then(response => {
            if (response.ok) {
              this.$auth.setToken(
                response.body.access_token, response.body.expires_in + Date.now(), u.userName);
              this.init(u);
            }
          }, error => {
            this.loginCount++
            this.failed = true
            this.wait = false
          });
        } else {
          this.init(u);
        }

      },
      init(u) {
        this.$emit('update')
          ga('send', {
              hitType: 'event',
              eventCategory: 'login_success',
              eventAction: 'login',
              eventLabel: 'loginBtn',
              eventValue: 150
          });
        this.logIn({
          userName: u.userName,
          cb: (user) => {
            this.$http.put(this.$helper.apiUrl()+'/users/' + user.id, user)
            this.wait = false
          }
        });
      },
      cb() {
        // console.log('calling back from cb');
      },
    },
    created() {
      // console.log('created Login');
    },
    mounted() {
      // this.$store.dispatch('getAllUsers')
      // console.log('mounted Login');
    },
  };
</script>
